module.exports = __webpack_public_path__ + "img/47.e9509d28.png";